import { useRecoilValue } from 'recoil';

import { enhanceNoteLoadingState } from 'components/practice/charts/ClinicalNote/MyScribeAI/state';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Loader from 'components/shared/Loader/Loader';

const EnhancementStatus = ({ children, type }) => {
  const enhanceNoteLoading = useRecoilValue(enhanceNoteLoadingState);

  let form = type;

  switch (type) {
    case 'goals':
      form = 'goals_narrative';
      break;
    case 'medications':
      form = 'medicationHistory';
      break;
    default:
      break;
  }

  return (
    <div className="flex flex-row gap-2">
      <div>{children}</div>
      {enhanceNoteLoading.includes(form) && (
        <div className="flex flex-row gap-2">
          <span>Enhancing...</span>
          <Loader
            outlined={false}
            color="primary"
            shade="50"
            className="bg-primary-500 text-primary-50"
          />
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(EnhancementStatus);
